/* eslint-disable @typescript-eslint/no-unused-vars */
import { Constants } from "appConstants";
import { ApplicationEventType } from "models/types";
import { AnalysisStatusLabel } from "services/types";

export interface ApplicationNewRecordOption {
	label: string;
	value: ApplicationEventType;
	status?: { label: string; value: string }[];
}

const ApplicationEventRespondToApplicantStatus = [
	{
		label: AnalysisStatusLabel.APROVADO,
		value: ApplicationEventType.SOLICITACAO_APROVADA
	},
	{
		label: AnalysisStatusLabel.SOLICITADA_ALTERACAO,
		value: ApplicationEventType.SOLICITAR_ALTERACAO
	},
	{
		label: AnalysisStatusLabel.REPROVADO,
		value: ApplicationEventType.SOLICITACAO_REPROVADA
	}
];

const RecordAddComment = {
	label: "Adicionar comentário",
	value: ApplicationEventType.ADICIONAR_COMENTARIO
};

const RecordRespondToInterested = {
	label: "Resposta ao interessado",
	value: ApplicationEventType.RESPOSTA_INTERESSADO
};

const RecordRemoveResponsibility = {
	label: "Devolver para a fila",
	value: ApplicationEventType.REMOVER_RESPONSABILIDADE
};

const analistActionOptions = [RecordAddComment, RecordRemoveResponsibility, RecordRespondToInterested, ...ApplicationEventRespondToApplicantStatus];

const ApplicationNewRecordOptions: {
	[key in Constants.UserRoleGroups]: ApplicationNewRecordOption[];
} = {
	[Constants.UserRoleGroups.ANALISTA]: analistActionOptions,
	[Constants.UserRoleGroups.ADMINISTRADOR]: analistActionOptions,
	[Constants.UserRoleGroups.SOLICITANTE]: []
};

export default ApplicationNewRecordOptions;
